import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import { message } from "antd";
import pdf from "./pdf.png";
import noInvoice from '../../images/Invoice not.jpeg'
import { editInvoiceDetails, raiseInvoiceOnQB } from "../../webServices/Apis";

const EditInvoice = ({
  invoiceDetails,
  close,
  setIsUpdated,
  qbCustomerId,
  qbServiceId,
}) => {
  const [loading, setLoading] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [invoicesStatuss, setInvoicesStatuss] = useState(
    invoiceDetails?.projectInvoice?.invoiceAccepted ? "Archived" : "Active"
  );
  const [paidStatus, setPaidStatus] = useState(
    invoiceDetails?.projectInvoice?.paidStatus ? "Paid" : "Unpaid"
  );
  const [comment, setComment] = useState(
    invoiceDetails?.projectInvoice?.comments
  );
  const [amount, setAmount] = useState(
    Number(invoiceDetails.projectInvoice.workingHours) +
                      Number(invoiceDetails.hstAmount)
  );
  const [prePaidStatus, setPrePaidStatus] = useState(
    invoiceDetails?.projectInvoice?.paidStatus
  );

  const [updateData, setUpdateData] = useState("");

  const handlePaidStatusChange = (newStatus) => {
    setInvoiceStatus((prevDetails) => ({
      ...prevDetails,
      projectInvoice: {
        ...prevDetails.projectInvoice,
        paidStatus: newStatus,
      },
    }));
  };

  const handleInvoiceStatus = (newInvoiceStatus) => {
    setInvoiceStatus((prevDetails) => ({
      ...prevDetails,
      projectInvoice: {
        ...prevDetails.projectInvoice,
        invoicesStatuss: newInvoiceStatus,
      },
    }));
  };

  const handleEditInvoiceDetails = async () => {
    // Prepare updated invoice data
    const updatedInvoiceDetails = {
      ...invoiceDetails,
      projectInvoice: {
        ...invoiceDetails.projectInvoice,
        paidStatus: paidStatus === "Paid",
        invoiceAccepted: invoicesStatuss === "Archived",
        comments: comment,
        amountPaid: amount,
      },
    };



    try {
      setLoading(true);

      if (localStorage.getItem("access_token")) {
        // Check if paidStatus has changed to "Paid" (i.e., condition for calling QuickBooks API
        if (prePaidStatus !== true && updatedInvoiceDetails?.projectInvoice?.paidStatus === true) {
          const qbInvoiceData = {
            CustomerRef: {
              value: qbCustomerId,
            },
            Line: [
              {
                DetailType: "SalesItemLineDetail",
                Amount: invoiceDetails?.projectInvoice?.amountPaid,
                Description: "Completed Tasks : " + invoiceDetails?.taskNames.join(", "),
                SalesItemLineDetail: {
                  ItemRef: {
                    value: qbServiceId,
                  },
                  UnitPrice: invoiceDetails?.projectInvoice?.amountPaid,
                  Qty: 1,
                },
              },
            ],
            TxnDate: invoiceDetails?.projectInvoice?.createdAt,
            BillAddr: {
              Line1: invoiceDetails?.street,
              City: invoiceDetails?.city,
              CountrySubDivisionCode: invoiceDetails?.prov,
              PostalCode: invoiceDetails?.code,
            },
            CurrencyRef: {
              value: "USD",
            },
          };

          const qbResponse = await raiseInvoiceOnQB(qbInvoiceData);

          if (qbResponse?.status !== 200) {
            message.error("Error while raising invoice on Quickbooks");
            return;
          }
        }
      }

      if (updatedInvoiceDetails.projectInvoice.amountPaid === null || updatedInvoiceDetails.projectInvoice.amountPaid === "" || updatedInvoiceDetails.projectInvoice.amountPaid < 1) {
        message.error("Total Payble Amount can not be zero")
        return;
      }
      const response = await editInvoiceDetails(updatedInvoiceDetails);

      if (response?.data?.success) {

        setUpdateData(response?.data?.data);
        setIsUpdated(true); // set the flag to true to indicate an update
        close();
        message.success(response?.data?.message);

      }
    } catch (error) {
      console.log("Error while edit invoice", error);
      if (error?.response?.status === 401) {
        message.error("Session Timeout !");
        localStorage.clear()
        window.location.href = "/login";
        return;
      }
      message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
    // Update the previous paidStatus to the current one
    setPrePaidStatus(paidStatus);
  };

  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, "0"); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as MM-DD-YYYY
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-lg w-[700px] max-h-[90vh] overflow-y-auto scrollbar-hidden">
        {loading && <Loader />}
        <h3 className="text-xl font-bold mb-6 text-center bg-blue-950 py-3 text-white ">
          {" "}
          Update Invoice Details{" "}
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">

          <div className="flex flex-col">
            <label
              htmlFor="number"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Id
            </label>
            <input
              type="number"
              name="number"
              placeholder="Invoice Number"
              value={invoiceDetails?.projectInvoice?.id}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="invoice-date"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="invoice-date"
              value={formatDate(invoiceDetails?.projectInvoice?.createdAt)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="start-date"
              className="text-sm font-medium text-gray-700"
            >
              Start Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="start-date"
              value={formatDate(invoiceDetails?.projectInvoice?.startDate)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="end-date"
              className="text-sm font-medium text-gray-700"
            >
              End Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="end-date"
              value={formatDate(invoiceDetails?.projectInvoice?.endDate)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="invoice-amount"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Amount
            </label>
            <input
              type="number"
              name="invoice-amount"
              value={invoiceDetails?.projectInvoice?.workingHours}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="hst rate"
              className="text-sm font-medium text-gray-700"
            >
              HST ( {invoiceDetails?.hstRate} %)
            </label>
            <input
              type="text"
              name="hst rate"
              value={invoiceDetails?.hstAmount ? Number(invoiceDetails.hstAmount).toFixed(2) : ""}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 bg-gray-300"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="total amount"
              className="text-sm font-medium text-gray-700"
            >
              Total Payble Amount
            </label>
            <input
              type="text"
              name="total amount"
              defaultValue={(
                      Number(invoiceDetails.projectInvoice.workingHours) +
                      Number(invoiceDetails.hstAmount)
                    ).toFixed(2)
                  }
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              className={`mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 ${paidStatus === 'Paid' ? 'bg-green-100' : 'bg-white'}`}
              disabled={paidStatus === 'Paid'}
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="falsepaidStatus"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Approval
            </label>
            <select
              name="paidStatus"
              value={paidStatus}
              onChange={(e) => {
                const newStatus = e.target.value === "Paid";
                setPaidStatus(e.target.value); // Update local state to reflect the selected option
                handlePaidStatusChange(newStatus); // Pass the boolean value to handlePaidStatusChange
              }}
              className={`mt-1 block w-full p-3 border border-gray-800 bg-white rounded-md focus:ring focus:ring-blue-500 ${invoiceDetails?.projectInvoice?.paidStatus ? 'bg-green-100 text-green-800 border-green-800' : 'bg-white text-gray-800 border-gray-800'}`}
              disabled={invoiceDetails?.projectInvoice?.paidStatus === true}
            >
              <option value="Paid">Approved</option>
              <option value="Unpaid">Not Approved</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="comments"
              className="text-sm font-medium text-gray-700"
            >
              Comments
            </label>
            <input
              type="text"
              name="comments"
              defaultValue={invoiceDetails?.projectInvoice?.comments === "null" ? "" : invoiceDetails?.projectInvoice?.comments}

              onChange={(e) => {
                setComment(e.target.value);
              }}
              className={`mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 ${paidStatus === 'Paid' ? 'bg-green-100' : 'bg-white'}`}
              disabled={paidStatus === 'Paid'}
            />
          </div>

          <div className="flexfalse flex-col">
            <label
              htmlFor="paidStatus"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Status
            </label>
            <select
              name="paidStatus"
              value={invoicesStatuss}
              onChange={(e) => {
                const newInvoiceStatus = e.target.value === "Archived";
                setInvoicesStatuss(e.target.value); // Update local state to reflect the selected option
                handleInvoiceStatus(newInvoiceStatus); // Pass the boolean value to handlePaidStatusChange
              }}
              className="mt-1 block w-full p-3 border border-gray-800 bg-white rounded-md focus:ring focus:ring-blue-500"
            >
              <option value="Archived">Archived</option>
              <option value="Active">Active</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="document"
              className="text-sm font-medium text-gray-700"
            >
              Document
            </label>

            {invoiceDetails?.projectInvoice?.uploadImage?.endsWith(".pdf") ? (
              <a
                href={invoiceDetails?.projectInvoice?.uploadImage}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center rounded-md p-2 hover:bg-gray-100 transition"
              >
                <img src={pdf} alt="PDF Document" className="mr-2 h-24" />
                {/* <span className="text-blue-600 hover:underline">View PDF</span> */}
              </a>
            ) : (
              <a
                href={invoiceDetails?.projectInvoice?.uploadImage}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center rounded-md p-2 hover:bg-gray-100 transition"
              >
                <img
                  src={invoiceDetails?.projectInvoice?.uploadImage || noInvoice}
                  alt="Uploaded Document"
                  className="mt-2 rounded-md h-32"
                />
                {/* <span className="ml-20 mt-20 text-blue-600 hover:underline">
                  View Document
                </span> */}
              </a>
            )}
          </div>

          <div className="flex flex-col">
            <h2 className="font-semibold mt-4">Task Done</h2>
            <div className="mt-2">
              {invoiceDetails?.projectTasks
                ?.map((task, index) => (
                  <div key={index} className="text-gray-700 ">
                    {index + 1}. {task?.taskName} - ${task?.taskBudget}
                  </div>
                ))}
            </div>
            <h2 className="font-semibold mt-4">Equipment Submitted:</h2>
            <div className="mt-2">
              {invoiceDetails?.projectInvoice?.equipmentSubmission
                ?.split(",")
                .map((equip, index) => (
                  <div key={index} className="text-gray-700">
                    {index + 1}. {equip}
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end mb-5 mr-10 gap-4">
          <button
            type="button"
            onClick={close}
            className="border border-gray-800 bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={() => {
              handleEditInvoiceDetails();
            }}
            className="border border-gray-800 bg-blue-300 text-black w-52 py-2 px-4 rounded-md hover:bg-blue-400 transition duration-200"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditInvoice;
